import api from './api'
import { endpoints } from './endpoints/data'

export default {
  getSettings() {
    return api.get(endpoints.get('settings'))
  }
}
